import axios from 'axios';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  SaktiAccessCodeCodeResponse,
  SaktiAccessCodeFilters,
  SaktiAccessCodeResponse,
} from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://dev-sakti.gbs.id/api/insight';
const SAKTI_API_KEY = process.env.REACT_APP_INSIGHT_API_KEY || '';

const createAccessCodeClient = (adminId?: string) => {
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': SAKTI_API_KEY,
      ...(adminId ? { 'X-Admin-ID': adminId } : {}),
    },
  });
};

export class SaktiAccessCodeApiService {
  static async getRequests(
    filters: SaktiAccessCodeFilters,
    adminId?: string
  ): Promise<SaktiAccessCodeResponse> {
    const client = createAccessCodeClient(adminId);
    const response = await client.get<SaktiAccessCodeResponse>(
      SAKTI_API_CONFIG.ACCESS_CODE_REQUESTS_PATH,
      {
        params: filters,
      }
    );
    return response.data;
  }

  static async getPlaintextCode(
    id: string,
    adminId?: string
  ): Promise<SaktiAccessCodeCodeResponse> {
    const client = createAccessCodeClient(adminId);
    const response = await client.get<SaktiAccessCodeCodeResponse>(
      SAKTI_API_CONFIG.ACCESS_CODE_DETAIL_PATH(id)
    );
    return response.data;
  }

  static async cancelRequest(id: string, adminId?: string): Promise<{ success: boolean; message: string }> {
    const client = createAccessCodeClient(adminId);
    const response = await client.post<{ success: boolean; message: string }>(
      SAKTI_API_CONFIG.ACCESS_CODE_CANCEL_PATH(id),
      {}
    );
    return response.data;
  }
}

export default SaktiAccessCodeApiService;
